export default "__VITE_ASSET__51919f6b__"